import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonLibsModule } from './common-libs/common-libs.module';
import { AuthComponent } from './auth.component';
import { SigninComponent } from './signin/signin.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginOtpComponent } from './Login-OTP/login-otp.component';
import { RedirectComponentComponent } from './redirect-component/redirect-component.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LOGIN_ROUTE } from './signin/signin.route';

@NgModule({
  declarations: [
    AuthComponent,
    SigninComponent,
    ResetPasswordComponent,
    LoginOtpComponent,
    RedirectComponentComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule, // Keep for non-standalone components like SigninComponent
    CommonLibsModule,
    RouterModule.forChild([LOGIN_ROUTE]),
    ChangePasswordComponent // Import standalone component
  ],
  exports: [
    AuthComponent,
    SigninComponent,
    ResetPasswordComponent,
    LoginOtpComponent,
    RedirectComponentComponent
    // Do not export ChangePasswordComponent unless needed by other modules
  ]
})
export class AuthModule {}